import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { apiCall, useAdminData, StringListEditor, ImageUploader } from './_helpers';

const StoryManager = ({ onMessage }) => {
  const [story, setStory, refetch] = useAdminData('story', {});
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try { await apiCall('PUT', 'story', story); onMessage('success', 'Saved'); refetch(); }
    catch (e) { onMessage('error', e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-md">
      <h2 className="text-2xl font-bold mb-6">Our Story (Homepage Section)</h2>
      <p className="text-sm text-gray-500 mb-6">For the full /our-story page content, edit it under Pages → Our Story.</p>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium mb-2">Title</label>
          <input type="text" value={story.title || ''} onChange={(e) => setStory({ ...story, title: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Subtitle</label>
          <input type="text" value={story.subtitle || ''} onChange={(e) => setStory({ ...story, subtitle: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Content Paragraphs</label>
          <StringListEditor items={story.content || []} onChange={(items) => setStory({ ...story, content: items })} placeholder="Paragraph text…" textarea />
        </div>
        <div className="border-t pt-6">
          <label className="block text-sm font-medium mb-2">Image (shown next to story on homepage)</label>
          <ImageUploader
            currentImage={story.image_url || ''}
            onUpload={(url) => setStory({ ...story, image_url: url })}
            label="Upload Story Image"
          />
          <input
            type="text"
            value={story.image_url || ''}
            onChange={(e) => setStory({ ...story, image_url: e.target.value })}
            placeholder="…or paste an image URL"
            className="w-full border rounded-lg px-4 py-2 mt-3"
            data-testid="story-image-url-input"
          />
        </div>
      </div>
      <button onClick={save} disabled={saving} className="mt-6 bg-[#C9A86C] text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A] disabled:opacity-50" data-testid="story-save-btn">
        <Save size={18} /> {saving ? 'Saving…' : 'Save Changes'}
      </button>
    </div>
  );
};

export default StoryManager;
